const getNavigationType = (): string | undefined => {
    const [navigation] = window.performance?.getEntriesByType?.('navigation') ?? []

    return (navigation as PerformanceNavigationTiming | undefined)?.type
}

const isReload = (): boolean => getNavigationType() === 'reload'

const isFreshTab = (): boolean => getNavigationType() === 'navigate' && window.history.length === 1

// `nextjsOrigin` is for the stands where the tiers sit on different ports: a hop back is
// cross-origin there and would otherwise read as an arrival from outside.
export const isExternalEntry = (nextjsOrigin?: string): boolean => {
    if (typeof window === 'undefined') {
        return false
    }

    if (isReload() || isFreshTab()) {
        return true
    }

    const { referrer } = document

    if (referrer === '') {
        return true
    }

    try {
        const { origin } = new URL(referrer)

        return origin !== window.location.origin && origin !== nextjsOrigin
    } catch {
        return true
    }
}
